module.exports = __webpack_public_path__ + "img/Character_Keqing_Thumb.d7b22114.png";